import { render, staticRenderFns } from "./ULogin.vue?vue&type=template&id=bd9d7382&scoped=true&"
import script from "./ULogin.vue?vue&type=script&lang=ts&"
export * from "./ULogin.vue?vue&type=script&lang=ts&"
import style0 from "./ULogin.vue?vue&type=style&index=0&id=bd9d7382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9d7382",
  null
  
)

export default component.exports